var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{style:(_vm.getHeight),attrs:{"src":_vm.url,"width":"100%","scrolling":"no"}},[_vm._v(_vm._s(_vm.$t("notSupportPDF")))])])}
var staticRenderFns = []

export { render, staticRenderFns }